import { useCallback, useEffect, useState } from "react";
import { listarCiclos, listarCursosPorCiclo } from "../../../../services/ciclosService";

const normalizeCiclo = (ciclo = {}) => {
  const anio = ciclo.anio ?? "";
  const codigo = ciclo.codigo?.trim() ?? "";
  const centro = ciclo.centro_alias?.trim() ?? "";
  const label = [anio, codigo, centro].filter(Boolean).join(" - ");
  return {
    id: ciclo.id,
    label,
    nombre: ciclo.nombre?.trim() || label,
    estado: ciclo.estado || "planificado",
    activo:
      typeof ciclo.activo === "boolean" ? ciclo.activo : ciclo.activo === 1 || ciclo.activo === "1",
    centro_id: ciclo.centro_id,
  };
};

export default function usePromocionCiclos() {
  const [ciclos, setCiclos] = useState([]);
  const [ciclosLoading, setCiclosLoading] = useState(true);
  const [ciclosError, setCiclosError] = useState(null);
  const [cursosPorCiclo, setCursosPorCiclo] = useState({});
  const [cursosLoading, setCursosLoading] = useState({});
  const [cursosError, setCursosError] = useState(null);

  const fetchCiclos = useCallback(async () => {
    setCiclosLoading(true);
    try {
      const data = await listarCiclos();
      const normalized = (Array.isArray(data) ? data : []).map(normalizeCiclo);
      setCiclos(normalized);
      setCiclosError(null);
    } catch (err) {
      console.error(err);
      setCiclosError(err.message || "No se pudo cargar la lista de ciclos.");
    } finally {
      setCiclosLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCiclos();
  }, [fetchCiclos]);

  const loadCursosPorCiclo = useCallback(
    async (cicloId) => {
      const key = cicloId ? String(cicloId) : "";
      if (!key) return [];
      if (cursosPorCiclo[key]) return cursosPorCiclo[key];

      setCursosLoading((prev) => ({ ...prev, [key]: true }));
      try {
        const data = await listarCursosPorCiclo(key);
        const cursos = Array.isArray(data) ? data : [];
        setCursosPorCiclo((prev) => ({ ...prev, [key]: cursos }));
        setCursosError(null);
        return cursos;
      } catch (err) {
        console.error(err);
        setCursosError(err.message || "No se pudo cargar los cursos del ciclo.");
        return [];
      } finally {
        setCursosLoading((prev) => ({ ...prev, [key]: false }));
      }
    },
    [cursosPorCiclo]
  );

  return {
    ciclos,
    ciclosLoading,
    ciclosError,
    reloadCiclos: fetchCiclos,
    cursosPorCiclo,
    cursosLoading,
    cursosError,
    loadCursosPorCiclo,
  };
}
